/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type ListServerNameOverridesSecurityOption1 = {
  projectSlugHeaderGramProject: string;
  sessionHeaderGramSession: string;
};

export type ListServerNameOverridesSecurityOption2 = {
  apikeyHeaderGramKey: string;
  projectSlugHeaderGramProject: string;
};

export type ListServerNameOverridesSecurity = {
  option1?: ListServerNameOverridesSecurityOption1 | undefined;
  option2?: ListServerNameOverridesSecurityOption2 | undefined;
};

export type ListServerNameOverridesRequest = {
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
};

/** @internal */
export type ListServerNameOverridesSecurityOption1$Outbound = {
  "project_slug_header_Gram-Project": string;
  "session_header_Gram-Session": string;
};

/** @internal */
export const ListServerNameOverridesSecurityOption1$outboundSchema:
  z.ZodMiniType<
    ListServerNameOverridesSecurityOption1$Outbound,
    ListServerNameOverridesSecurityOption1
  > = z.pipe(
    z.object({
      projectSlugHeaderGramProject: z.string(),
      sessionHeaderGramSession: z.string(),
    }),
    z.transform((v) => {
      return remap$(v, {
        projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
        sessionHeaderGramSession: "session_header_Gram-Session",
      });
    }),
  );

export function listServerNameOverridesSecurityOption1ToJSON(
  listServerNameOverridesSecurityOption1:
    ListServerNameOverridesSecurityOption1,
): string {
  return JSON.stringify(
    ListServerNameOverridesSecurityOption1$outboundSchema.parse(
      listServerNameOverridesSecurityOption1,
    ),
  );
}

/** @internal */
export type ListServerNameOverridesSecurityOption2$Outbound = {
  "apikey_header_Gram-Key": string;
  "project_slug_header_Gram-Project": string;
};

/** @internal */
export const ListServerNameOverridesSecurityOption2$outboundSchema:
  z.ZodMiniType<
    ListServerNameOverridesSecurityOption2$Outbound,
    ListServerNameOverridesSecurityOption2
  > = z.pipe(
    z.object({
      apikeyHeaderGramKey: z.string(),
      projectSlugHeaderGramProject: z.string(),
    }),
    z.transform((v) => {
      return remap$(v, {
        apikeyHeaderGramKey: "apikey_header_Gram-Key",
        projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      });
    }),
  );

export function listServerNameOverridesSecurityOption2ToJSON(
  listServerNameOverridesSecurityOption2:
    ListServerNameOverridesSecurityOption2,
): string {
  return JSON.stringify(
    ListServerNameOverridesSecurityOption2$outboundSchema.parse(
      listServerNameOverridesSecurityOption2,
    ),
  );
}

/** @internal */
export type ListServerNameOverridesSecurity$Outbound = {
  Option1?: ListServerNameOverridesSecurityOption1$Outbound | undefined;
  Option2?: ListServerNameOverridesSecurityOption2$Outbound | undefined;
};

/** @internal */
export const ListServerNameOverridesSecurity$outboundSchema: z.ZodMiniType<
  ListServerNameOverridesSecurity$Outbound,
  ListServerNameOverridesSecurity
> = z.pipe(
  z.object({
    option1: z.optional(
      z.lazy(() => ListServerNameOverridesSecurityOption1$outboundSchema),
    ),
    option2: z.optional(
      z.lazy(() => ListServerNameOverridesSecurityOption2$outboundSchema),
    ),
  }),
  z.transform((v) => {
    return remap$(v, {
      option1: "Option1",
      option2: "Option2",
    });
  }),
);

export function listServerNameOverridesSecurityToJSON(
  listServerNameOverridesSecurity: ListServerNameOverridesSecurity,
): string {
  return JSON.stringify(
    ListServerNameOverridesSecurity$outboundSchema.parse(
      listServerNameOverridesSecurity,
    ),
  );
}

/** @internal */
export type ListServerNameOverridesRequest$Outbound = {
  "Gram-Key"?: string | undefined;
  "Gram-Session"?: string | undefined;
  "Gram-Project"?: string | undefined;
};

/** @internal */
export const ListServerNameOverridesRequest$outboundSchema: z.ZodMiniType<
  ListServerNameOverridesRequest$Outbound,
  ListServerNameOverridesRequest
> = z.pipe(
  z.object({
    gramKey: z.optional(z.string()),
    gramSession: z.optional(z.string()),
    gramProject: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      gramKey: "Gram-Key",
      gramSession: "Gram-Session",
      gramProject: "Gram-Project",
    });
  }),
);

export function listServerNameOverridesRequestToJSON(
  listServerNameOverridesRequest: ListServerNameOverridesRequest,
): string {
  return JSON.stringify(
    ListServerNameOverridesRequest$outboundSchema.parse(
      listServerNameOverridesRequest,
    ),
  );
}
